module.exports = __webpack_public_path__ + "static/img/8.94ba61b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/8.png
// module id = NJ0R
// module chunks = 213